/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LineItemType {
    REGISTRATION_FEE = 'registration_fee',
    ADJUSTMENT = 'adjustment',
    PARTNER_OFFERING = 'partner_offering',
    FEE = 'fee',
    CREDIT = 'credit',
}
